/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ecommerce/023-barcode': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M15 102.65h482c8.284 0 15-6.716 15-15s-6.716-15-15-15H15c-8.284 0-15 6.716-15 15s6.716 15 15 15zM497 409.35H15c-8.284 0-15 6.716-15 15s6.716 15 15 15h482c8.284 0 15-6.716 15-15s-6.716-15-15-15zM63.2 136.783c-8.284 0-15 6.716-15 15v192.4c0 8.284 6.716 15 15 15h64.267c8.284 0 15-6.716 15-15v-192.4c0-8.284-6.716-15-15-15zm49.267 192.401H78.2v-162.4h34.267zM256 136.783c-8.284 0-15 6.716-15 15v192.4c0 8.284 6.716 15 15 15h64.267c8.284 0 15-6.716 15-15v-192.4c0-8.284-6.716-15-15-15zm49.267 192.401H271v-162.4h34.267zM176.733 151.783v192.4c0 8.284 6.716 15 15 15s15-6.716 15-15v-192.4c0-8.284-6.716-15-15-15s-15 6.716-15 15zM369.533 151.783v192.4c0 8.284 6.716 15 15 15s15-6.716 15-15v-192.4c0-8.284-6.716-15-15-15s-15 6.716-15 15zM433.8 151.783v192.4c0 8.284 6.716 15 15 15s15-6.716 15-15v-192.4c0-8.284-6.716-15-15-15s-15 6.716-15 15z"/>'
  }
})
